import React, { useEffect } from "react";
import "./Skills.scss";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import SkillsList from "./SkillsList";
import Services from "../Services/Services";
const Skills = () => {
  const controls = useAnimation();
  const { ref, inView } = useInView();
  const headers = {
    hidden: {
      opacity: 1,
      top: "10%",
      left: "45%",
    },
    show: {
      opacity: 1,
      top: "0%",
      left: "10%",
      scale: 0.9,

      transition: {
        duration: 0.5,
        type: "bounce",

        delay: 0.1,
      },
    },
  };

  useEffect(() => {
    if (inView) controls.start("show");
  }, [controls, inView]);

  return (
    <div className="skills">
      <motion.h1
        ref={ref}
        animate={controls}
        initial="hidden"
        variants={headers}
      >
        Skills
      </motion.h1>
      <div className="skillsGrid">
        <SkillsList />
        <Services />
      </div>
    </div>
  );
};

export default Skills;
